import { Typography } from "@mui/material";

const LabelValue = ({ label, value }: { label: string; value: string }) => (
  <>
    <Typography
      className="title"
      mb={0.5}
      fontSize="14px"
      color="#54565A"
      sx={{ wordBreak: "break-word" }}
    >
      {label}
    </Typography>
    <Typography sx={{ wordBreak: "break-word" }}>{value}</Typography>
  </>
);

export default LabelValue;
